module.exports = __webpack_public_path__ + "static/media/x1.5f082abb.jpg";